import { useState, useEffect } from 'react';
import { trackEvent } from '../../../lib/tracking';

// === À REMPLACER quand tu auras les fichiers ===
const BADGE_IMAGE = '/images/recognition/ICCA_2026_Winner.png';
const BADGE_LINK = 'https://www.critical-communications-world.com/2026-icca-winners';
const BADGE_ALT = 'Winner — International Critical Communications Awards 2026';
// ===============================================

const STORAGE_KEY = 'candyvoice.award_badge.dismissed';

export default function AwardBadge() {
  const [visible, setVisible] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fermé le badge
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      // Délai d'apparition pour ne pas distraire au chargement initial
      const showTimer = setTimeout(() => setVisible(true), 800);
      const animTimer = setTimeout(() => setAnimateIn(true), 900);
      return () => {
        clearTimeout(showTimer);
        clearTimeout(animTimer);
      };
    }
  }, []);

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(STORAGE_KEY, '1');
    setAnimateIn(false);
    setTimeout(() => setVisible(false), 300);
    trackEvent('award_badge_dismiss');
  };

  const handleClick = () => {
    trackEvent('award_badge_click');
  };

  if (!visible) return null;

  return (
    <a
      href={BADGE_LINK}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={`
        fixed top-24 right-6 z-50 group
        block cursor-pointer
        transition-all duration-300 ease-out
        ${animateIn ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'}
      `}
      aria-label="View our award"
    >
      {/* Bouton fermeture */}
      <button
        onClick={handleDismiss}
        className="
          absolute -top-2 -right-2 z-10
          w-7 h-7 rounded-full
          bg-white border border-gray-300
          shadow-md
          flex items-center justify-center
          text-gray-500 hover:text-gray-900 hover:border-gray-400
          transition-colors
          opacity-0 group-hover:opacity-100
          focus:opacity-100
        "
        aria-label="Close award badge"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
          <path d="M9.5 2.5 6 6 2.5 2.5 1.5 3.5 5 7 1.5 10.5 2.5 11.5 6 8 9.5 11.5 10.5 10.5 7 7 10.5 3.5z"/>
        </svg>
      </button>

      {/* L'image du badge */}
      <img
        src={BADGE_IMAGE}
        alt={BADGE_ALT}
        className="
          w-[140px] md:w-[180px]
          h-auto
          drop-shadow-xl
          transition-transform duration-200
          group-hover:scale-105
        "
      />
    </a>
  );
}
